<template>
  <div>
    <Form :label-width="100">
      <FormItem label="房间id：" >
        <Input type="text" disabled></Input>
      </FormItem>
      <FormItem label="房间状态：">
        <section class="display-flex">
          <Select :disabled="!editState" transfer>
            <Option :value="1">关联物品</Option>
            <Option :value="2">无物品</Option>
          </Select>
          <Button type="primary" @click="editRoomState">{{!editState? '更改状态' : '保存状态'}}</Button>
        </section>
      </FormItem>
      <FormItem label="是否有门锁：">
        <section class="display-flex">
          <Select transfer>
            <Option :value="1">无</Option>
            <Option :value="2">有</Option>
          </Select>
        </section>
      </FormItem>
      <FormItem label="名称：" >
        <Input type="text" disabled></Input>
      </FormItem>
      <FormItem label="Xbed房名：" >
        <Input type="text"></Input>
      </FormItem>
      <FormItem label="省市区：" >
        <Input type="text" disabled></Input>
      </FormItem>
      <FormItem label="所属门店：">
        <section class="display-flex">
          <Select transfer>
            <Option :value="1">无</Option>
            <Option :value="2">有</Option>
          </Select>
        </section>
      </FormItem>
      <FormItem label="所属楼宇：">
        <section class="display-flex">
          <Select transfer>
            <Option :value="1">无</Option>
            <Option :value="2">有</Option>
          </Select>
        </section>
      </FormItem>
      <section class="display-flex">
        <FormItem label="楼层：">
          <Input type="text" class="inline-width">
            <span slot="append">/层</span>
          </Input>
        </FormItem>
        <FormItem label="房号：">
          <Input type="text" class="inline-width">
            <span slot="append">/号</span>
          </Input>
        </FormItem>
        <FormItem label="面积：">
          <Input type="text" class="inline-width">
            <span slot="append">/平方米</span>
          </Input>
        </FormItem>
      </section>
      <FormItem label="默认价格：">
        <section class="display-flex">
          <Input type="text" class="inline-width">
            <span slot="append">/元</span>
          </Input>
        </section>
      </FormItem>
      <FormItem label="租赁方式：">
        <CheckboxGroup>
          <Checkbox label="短租"></Checkbox>
          <Checkbox label="长租"></Checkbox>
        </CheckboxGroup>
      </FormItem>
      <section class="display-flex">
        <FormItem label="长租押金：">
          <Input type="text" class="inline-width">
            <span slot="append">/元</span>
          </Input>
        </FormItem>
        <FormItem label="长租折扣：">
          <Input type="text" class="inline-width"></Input>
          <span class="red-color">*设置长租价格为短租价格的倍数</span>
        </FormItem>
      </section>
      <FormItem label="蓝主人信息：">
        <Row class-name="blue-hoster-info">
          <Col span="5">业主信息</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">楼宇名</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">详细地址</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">房屋结构</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">房型</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">合作期限</Col>
          <Col span="5">123321</Col>
        </Row>
        <Row class-name="blue-hoster-info">
          <Col span="5">合作类型</Col>
          <Col span="5">123321</Col>
        </Row>
      </FormItem>
      <FormItem label="房间二维码：">
        <Button type="primary">获取二维码</Button>
      </FormItem>
    </Form>

    <Modal v-model="confirmEditModal.display" ref="confirmEditModal" title="修改房间状态" :width="400">
      <p>确定修改房间状态吗？</p>
      <p>一经确定将无法修改</p>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      editState: false,
      confirmEditModal: {
        display: false,
      }
    };
  },
  methods: {
    editRoomState() {
      if (this.editState) {

        this.confirmEditModal.display = true;
      }
      this.editState = !this.editState;

    }
  }
};
</script>

<style lang="scss" scoped>
.display-flex {
  display: flex;
  flex-direction: row;
  .ivu-select {
    width: 200px;
  }
  button {
    margin-left: 20px;
  }
  .inline-width{
    width: 200px;
  }
}
.blue-hoster-info{
  font-size: 14px;
}
span.red-color{
  margin-left: 12px;
  color: #ed3f14;
}
</style>



// WEBPACK FOOTER //
// src/pages/room/room-detail/base-info.vue